import o from"react";var p=({classProps:r,tag:e,omit:n,children:s})=>{let t=`${e}`;return n?o.createElement(o.Fragment,null,s):o.createElement(t,{className:r?.root},s)};export{p as a};
